<template>
  <div
    v-show="activeRoomId!=''"
    class="col-lg-3 message-view chat-profile-view chat-sidebar"
    id="task_window"
  >
    <div class="chat-window video-window">
      <div class="tab-content chat-contents">
        <div class="content-full tab-pane show active" id="profile_tab">
          <div class="display-table">
            <div class="table-row">
              <div class="table-body">
                <div class="table-content">
                  <div class="chat-profile-img">
                    <div class="edit-profile-img">
                      <img src="@/assets/profiles/avatar-02.jpg" alt />
                      <!-- <span class="change-img">Change Image</span> -->
                    </div>
                    <h3 class="user-name m-t-10 mb-0">{{roomDetail.room_title}}</h3>
                    <small class="text-muted">{{roomDetail.provider}}</small>
                  </div>
                  <div class="chat-profile-info">
                    <ul class="user-det-list">
                      <li>
                        <span>Phone:</span>
                        <span class="float-right text-muted">{{roomDetail.room_number}}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="transfer-files">
                    <ul class="nav nav-tabs nav-tabs-solid nav-justified mb-0">
                      <li class="nav-item">
                        <a class="nav-link active" href="#all_files" data-toggle="tab">
                          All
                          Files
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" href="#my_files" data-toggle="tab">My Files</a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane show active" id="all_files">
                        <!-- <ul class="files-list">
                          <li>
                            <div class="files-cont">
                              <div class="file-type">
                                <span class="files-icon">
                                  <i class="fa fa-file-pdf-o"></i>
                                </span>
                              </div>
                              <div class="files-info">
                                <span class="file-name text-ellipsis">
                                  AHA
                                  Selfcare Mobile Application
                                  Test-Cases.xls
                                </span>
                                <span class="file-author">
                                  <a href="#">
                                    Loren
                                    Gatlin
                                  </a>
                                </span>
                                <span class="file-date">
                                  May 31st at
                                  6:53 PM
                                </span>
                              </div>
                              <ul class="files-action">
                                <li class="dropdown dropdown-action">
                                  <a
                                    href
                                    class="dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i class="material-icons">more_horiz</i>
                                  </a>
                                  <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javascript:void(0)">Download</a>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      data-toggle="modal"
                                      data-target="#share_files"
                                    >Share</a>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul> -->
                      </div>
                      <div class="tab-pane" id="my_files">
                        <!-- <ul class="files-list">
                          <li>
                            <div class="files-cont">
                              <div class="file-type">
                                <span class="files-icon">
                                  <i class="fa fa-file-pdf-o"></i>
                                </span>
                              </div>
                              <div class="files-info">
                                <span class="file-name text-ellipsis">
                                  AHA
                                  Selfcare Mobile Application
                                  Test-Cases.xls
                                </span>
                                <span class="file-author">
                                  <a href="#">John Doe</a>
                                </span>
                                <span class="file-date">
                                  May 31st at
                                  6:53 PM
                                </span>
                              </div>
                              <ul class="files-action">
                                <li class="dropdown dropdown-action">
                                  <a
                                    href
                                    class="dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i class="material-icons">more_horiz</i>
                                  </a>
                                  <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javascript:void(0)">Download</a>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      data-toggle="modal"
                                      data-target="#share_files"
                                    >Share</a>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Sidebar -->
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      roomDetail: {
        room_title: "",
        provider: "",
        room_photo: "",
        update_datetime: 0,
        room_number: 0
      }
    };
  },
  computed: {
    ...mapGetters(["activeRoomId", "getRoomById"])
  },
  async created() {
    this.$root.$on("switchRoom", async roomArr => {
      // console.log("right rooomo", roomArr);
      // console.log(this.$store.getters.getRoomById(roomArr.room_id));
      this.roomDetail = this.$store.getters.getRoomById(roomArr.room_id);
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/views/agentconnect/RightSidebar.vue